import { WORDS } from '../constants/wordlist';
import { VALID_GUESSES } from '../constants/validGuesses'
import { WRONG_SPOT_MESSAGE, NOT_CONTAINED_MESSAGE } from '../constants/strings'
import { getGuessStatuses } from './statuses'
import moment from 'moment';
import axios  from 'axios';

export const isWordInWordList = (word: string) => {
  return (
    WORDS.includes(word.toLowerCase()) ||
    VALID_GUESSES.includes(word.toLowerCase())
  )
}

export const isWinningWord = (solutions: any, word: string, step: number) => {
  if (step === 1) {
    return solutions.solution === word
  }

  if (step === 2) {
    return solutions.solution2 === word
  }

  if (step === 3) {
    return solutions.solution3 === word
  }

  if (step === 4) {
    return solutions.solution4 === word
  }

  if (step === 5) {
    return solutions.solution5 === word
  }
  
}

// build a set of previously revealed letters - present and correct
// guess must use correct letters in that space and any other revealed letters
// also check if all revealed instances of a letter are used (i.e. two C's)
export const findFirstUnusedReveal = (words: any, word: string, guesses: string[], currentStep: number) => {
  if (guesses.length === 0) {
    return false
  }

  const lettersLeftArray = new Array<string>()
  const guess = guesses[guesses.length - 1]
  const statuses = getGuessStatuses(words, guess, currentStep)

  for (let i = 0; i < guess.length; i++) {
    if (statuses[i] === 'correct' || statuses[i] === 'present') {
      lettersLeftArray.push(guess[i])
    }
    if (statuses[i] === 'correct' && word[i] !== guess[i]) {
      return WRONG_SPOT_MESSAGE(guess[i], i + 1)
    }
  }

  // check for the first unused letter, taking duplicate letters
  // into account - see issue #198
  let n
  for (const letter of word) {
    n = lettersLeftArray.indexOf(letter)
    if (n !== -1) {
      lettersLeftArray.splice(n, 1)
    }
  }

  if (lettersLeftArray.length > 0) {
    return NOT_CONTAINED_MESSAGE(lettersLeftArray[0])
  }
  return false
}

const getThemedPuzzles = () => {
  return axios.get("https://gamesfeeds.blob.core.windows.net/hurdle/custom-puzzles.json");
}

export const getWordsOfDay: any = async () => {
 
  // January 1, 2022 Game Epoch
  const epochMs = new Date("January 1, 2022").valueOf()
  const msInDay = 86400000
  
  const today = new Date();  
  let now = today.getTime();
  if (moment().isDST()) {
    now = moment(now).add(1, "hour").valueOf();
  }
  let index1 = Math.floor((now - epochMs) / msInDay)
  const daysInRoughlyOneYear = 365
  let index2 = index1 + daysInRoughlyOneYear; 
  let index3 = index2 + daysInRoughlyOneYear;
  let index4 = index3 + daysInRoughlyOneYear;
  let index5 = index4 + daysInRoughlyOneYear;
  let nextday = (index1 + 1) * msInDay + epochMs
  if (moment().isDST()) {
    nextday = moment(nextday).subtract(1, "hour").valueOf();
  }

  let _words = WORDS;
  let customListValid = false;
  //Check for themed word list - //https://gamesfeeds.blob.core.windows.net/hurdle/custom-puzzles.json
  try {
    let themedListDateKey = moment().format('YYMMDD');
    const puzzlesCDN = await getThemedPuzzles();;
    let availableWords = puzzlesCDN.data;
    const availableDates = Object.keys(availableWords);
    
    if (availableDates.includes(themedListDateKey)) {
      customListValid = availableWords[themedListDateKey].every((word: string) => {
        return word.length === 5;
      });
      if (customListValid) {
        VALID_GUESSES.push(availableWords[themedListDateKey][0].toLowerCase());
        VALID_GUESSES.push(availableWords[themedListDateKey][1].toLowerCase());
        VALID_GUESSES.push(availableWords[themedListDateKey][2].toLowerCase());
        VALID_GUESSES.push(availableWords[themedListDateKey][3].toLowerCase());
        VALID_GUESSES.push(availableWords[themedListDateKey][4].toLowerCase());
        index1 = 0;
        _words = availableWords[themedListDateKey];
      }
    } 
  } catch(e) {

  }

  return {
    solution: customListValid ? _words[0] : _words[index1 % _words.length].toUpperCase(),
    solution2: customListValid ? _words[1] : _words[index2 % _words.length].toUpperCase(),
    solution3: customListValid ? _words[2] : _words[index3 % _words.length].toUpperCase(),
    solution4: customListValid ? _words[3] : _words[index4 % _words.length].toUpperCase(),
    solution5: customListValid ? _words[4] : _words[index5 % _words.length].toUpperCase(),
    solutionIndex: index1,
    tomorrow: nextday,
  }
}

export const { solution, solution2, solution3, solution4, solution5, solutionIndex, tomorrow } =  getWordsOfDay()
